import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import PhotoStrip from "@/components/PhotoStrip";
import Marquee from "@/components/Marquee";
import Convenience from "@/components/home/Convenience";
import ServicesGrid from "@/components/home/ServicesGrid";
import JeremyPreview from "@/components/home/JeremyPreview";
import Reviews from "@/components/home/Reviews";
import InsuranceSection from "@/components/home/InsuranceSection";
import LocationCTA from "@/components/home/LocationCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Advantage Primary Health | Primary Care in Prescott Valley, AZ"
        description="Military family-owned primary care in Prescott Valley, AZ with evening and weekend appointments. Accepting AHCCCS, UnitedHealthcare, Aetna, Medicare, Cigna, AZ Complete Health, Ambetter, Wellcare, and self-pay. Book online or call (928) 327-7528."
      />
      <Hero />
      <PhotoStrip />
      <Marquee />
      <Convenience />
      <ServicesGrid />
      <JeremyPreview />
      <InsuranceSection />
      <Reviews />
      <LocationCTA />
    </main>
  );
}
